/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Pin Icon component.
 */
export const SystemPinIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M12 13.0417H7L9.77778 11.4167V7.625L8.11111 6H12H16.4444L14.2222 7.625V11.4167L17 13.0417H12ZM12 13.0417V19' stroke={iconColor} strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default SystemPinIcon;
